<template>
  <div class="app-error">
    <DeepError :headline="t('error')" :text="errorMessage">
      <template #actions></template>
    </DeepError>
    <AppLocale />
  </div>
</template>

<script setup lang="ts">
import { DeepError } from '@deepcloud/deep-ui-lib'
import AppLocale from './components/AppLocale'

defineProps({
  errorMessage: {
    type: String,
    default: undefined,
  },
})

const { t } = useI18n()
</script>
<style lang="css" scoped>
.app-error {
  height: 100dvh;
}
</style>
